import { InformationIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";

interface InfoNoteProps {
  title?: string;
  message: string;
  className?: string;
  /** Screen-reader name, so several notes on one panel stay distinguishable. */
  ariaLabel?: string;
}

const InfoNote = ({
  title = "Information",
  message,
  className,
  ariaLabel = "information"
}: InfoNoteProps) => {
  return (
    <div
      className={cn("flex items-start gap-2", className)}
      role="note"
      aria-label={ariaLabel}
    >
      <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-blue-50">
        <InformationIcon
          className="fill-royal-blue size-4"
          data-testid="information-icon"
        />
      </div>

      <div className="flex flex-col">
        <div className="text-royal-blue leading-6 font-semibold text-xs">
          {title}
        </div>
        <span className="text-[10px] text-txtBody whitespace-pre-line">
          {message}
        </span>
      </div>
    </div>
  );
};

export default InfoNote;
